"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDefaultStrategy = createDefaultStrategy;
const constants_1 = require("../constants");
const validationHelpers_1 = require("../common/validationHelpers");
const DEFAULT_MAX_LENGTH = 12;
const DEFAULT_MIN_LENGTH = 10;
function createDefaultStrategy(options) {
    var _a, _b;
    const { enableCheckDigit, proNumberLengthConstraints } = options;
    const maxLength = (_a = proNumberLengthConstraints === null || proNumberLengthConstraints === void 0 ? void 0 : proNumberLengthConstraints.maxLength) !== null && _a !== void 0 ? _a : DEFAULT_MAX_LENGTH;
    const minLength = (_b = proNumberLengthConstraints === null || proNumberLengthConstraints === void 0 ? void 0 : proNumberLengthConstraints.minLength) !== null && _b !== void 0 ? _b : DEFAULT_MIN_LENGTH;
    const getCheckDigit = (proNumber) => {
        const trimmedPro = proNumber.trim();
        if (isNaN(Number(trimmedPro))) {
            return 0;
        }
        let paddedPro = trimmedPro;
        const targetLength = maxLength - 1;
        if (paddedPro.length < targetLength) {
            paddedPro = paddedPro.padStart(targetLength, "0");
        }
        const actualProNumber = Number(paddedPro.substr(0, maxLength - 2));
        const getCalcDigit = Math.floor(actualProNumber / 7);
        return actualProNumber - getCalcDigit * 7;
    };
    const getProNumberWithCheckDigit = ({ proNumber, }) => {
        if (enableCheckDigit && proNumber.length === maxLength - 1) {
            return proNumber + getCheckDigit(proNumber).toString();
        }
        return proNumber;
    };
    const validateProNumber = (validationInput) => {
        const { proNumber } = validationInput;
        const actualLength = proNumber.length;
        // Check if length is under minimum
        if (actualLength < minLength) {
            return (0, validationHelpers_1.createValidationError)(constants_1.PRO_VALIDATION_ERROR_TYPES.PRO_NUMBER_MIN, {
                minLength,
            });
        }
        // Check if length exceeds maximum
        if (actualLength > maxLength) {
            return (0, validationHelpers_1.createValidationError)(constants_1.PRO_VALIDATION_ERROR_TYPES.PRO_NUMBER_MAX, {
                maxLength,
            });
        }
        // Check digit validation for default strategy
        if (enableCheckDigit) {
            // Require exactly maxLength when check digit is enabled (base number + check digit = maxLength)
            if (actualLength !== maxLength) {
                return (0, validationHelpers_1.createValidationError)(constants_1.PRO_VALIDATION_ERROR_TYPES.PRO_NUMBER_MIN, {
                    minLength: maxLength,
                });
            }
            // Validate check digit
            const enteredCheckDigit = Number(proNumber.slice(-1));
            const calculatedCheckDigit = getCheckDigit(proNumber.slice(0, maxLength - 1));
            if (enteredCheckDigit !== calculatedCheckDigit) {
                return (0, validationHelpers_1.createValidationError)(constants_1.PRO_VALIDATION_ERROR_TYPES.INVALID_CHECK_DIGIT);
            }
        }
        return null;
    };
    const isTempProNumber = (proNumber) => {
        return false;
    };
    return {
        getProNumberWithCheckDigit,
        validateProNumber,
        isTempProNumber,
        getCheckDigit,
    };
}
